import React, { useState } from "react";
import "./login.css";
import LeftPanel from "./leftPanel";
import { Form, Formik } from "formik";
import * as yup from "yup";
import CustomInput from "../../components/CustomInput/CustomInput";
import apiUtil from "../../api/apiUtil";
import api from "../../api/api";
import secureLocalStorage from "react-secure-storage";
import logo from "../../images/smk_logo.png";
import { message } from "antd";
import { useNavigate } from "react-router-dom";
import authStore from "../../store/authStore";

const Login = () => {
  const setAuthData = authStore((state) => state.setAuthData);
  const setRememberMe = authStore((state) => state.setRememberMe);
  const rememberMe = authStore((state) => state.rememberMe);
  const [isSMK, setIsSMK] = useState(true);
  const [isPartner, setIsPartner] = useState(false);
  const [isRemember, setIsRemember] = useState(rememberMe);
  const navigate = useNavigate();

  const [isOrganization, setIsOrganization] = useState(true);
  const [isIndividual, setIsIndividual] = useState(false);

  const RememberMe = (e) => {
    const isChecked = e.target.checked;
    setIsRemember(isChecked);
    setRememberMe(isChecked);
    if (!isChecked) {
      secureLocalStorage.removeItem("username");
    }
  };

  const handleSubmit = async (values, actions) => {
    const user = {
      userName: values.username,
      password: values.password,
      userType: values.loginType,
    };

    if (isRemember) {
      secureLocalStorage.setItem("username", values.username);
    }

    api.post("Authentication/Authenticate", user).then((result) =>
      apiUtil.parseResult(
        result,
        (response) => {
          if (response.data.code === 200) {

            const userData = response.data.data;
            setAuthData({
              userId: userData.userId,
              brandId: userData.brandId,
              username: userData.username,
              token: userData.token
            });

            setRememberMe(isRemember);
            navigate("/");
          } else {
            message.warning(response.data.message);
          }
        },
        (error) => {
          console.log(error);
        }
      )
    );

    actions.setSubmitting(false);
  };
  const onClickBtn = () => {
    setIsSMK(!isSMK);
    setIsPartner(!isPartner);
  };

  let schema = yup.object().shape({
    username: yup.string().required("Please enter the username."),
    password: yup
      .string()
      .required("Please enter the password.")
      .test("len", "Password must be at least 8 characters.", (val) =>
        val && val.length >= 8
      ),
  });

  return (
    <div className="d-flex bg-smk bg-white container-fluid justify-content-center align-items-center">
      <div className="col-12 h-100 d-flex justify-content-center align-items-center">
        <div className="rightPanel">
          <div className="d-flex justify-content-center align-items-center mb-4">
            <img src={logo} alt="logo" className="w-25" />
          </div>
          <div className={`loginForm ${!isSMK && "PTR-form"}`}>
            <Formik
              initialValues={{
                username: isRemember ? secureLocalStorage.getItem("username") || "" : "",
                loginType: "1",
              }}
              validationSchema={schema}
              onSubmit={handleSubmit}
            >
              {({ values, errors, touched, setFieldValue }) => {
                return (
                  <Form className="wrapper">
                    <h4 className="title">Please login to your dashboard</h4>
                    {!isSMK && (
                      <div className="radioButtonContainer">
                        <label
                          className={`organizationHolder ${isOrganization ? "btn_Active" : ""}`}
                          onClick={() => {
                            values.loginType = "1";
                            setIsOrganization(true);
                            setIsIndividual(false);
                          }}
                          onKeyDown={(e) => {
                            if (e.key === "Enter" || e.key === " ") {
                              setIsIndividual(false);
                            }
                          }}
                        >
                          Organization<input
                            type="radio"
                            name="loginType"
                            value="1"
                            checked={values.loginType === "1"}
                            onChange={() => console.log(values.loginType)}
                          />
                          <span className="radio-item-1"></span>
                        </label>
                        <label
                          className={`individualHolder ${isIndividual ? "btn_Active" : ""}`}
                          onClick={() => {
                            values.loginType = "2";
                            setIsOrganization(false);
                            setIsIndividual(true);
                          }}
                          onKeyDown={(e) => {
                            if (e.key === "Enter" || e.key === " ") {
                              setIsOrganization(false);
                            }
                          }}
                        >
                          Brand<input
                            type="radio"
                            name="loginType"
                            value="2"
                            checked={values.loginType === "2"}
                            onChange={() => console.log(values.loginType)}
                          />
                          <span className="radio-item-2"></span>
                        </label>

                      </div>
                    )}
                    <CustomInput
                      name="username"
                      type="username"
                      placeholder="Username"
                      customclass="input_wrapper input_username"
                    />
                    <div className="mt-3"></div>
                    <CustomInput
                      name="password"
                      type="password"
                      placeholder="Password"
                      customclass="input_wrapper input_password"
                    />

                    <div className="toggle-switch mt-3">
                      <span className="remember">
                        Remember me
                      </span>
                      <label htmlFor="remember" className="switch">
                        <input
                          type="checkbox"
                          id="remember"
                          name="remember"
                          checked={isRemember}
                          onChange={RememberMe}
                        />
                        <span className="slider round"></span>
                      </label>
                    </div>
                    <button className="login_btn" type="submit">
                      Login
                    </button>
                  </Form>
                );
              }}
            </Formik>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
